<template>
	<div class="table-container-layout" :class="{ 'has-selection': !isEditMode && isSelectionOn }">
		<div :class="['table-field-layout', { 'is-selection-on': isSelectionOn, 'is-multiple-selection': isMultipleSelection }]">
			<NewTableView
				class="flex-1"
				:headers="tableHeaders"
				:rows="rows"
				:selectedRows.sync="localSelectedRows"
				:fieldsEditable="fieldsEditable"
				:addRowEnabled="addRowEnabled"
				:isSelectionOn="isSelectionOn"
				:isMultipleSelection="isMultipleSelection"
				:isSearchOn="isSearchOn"
				@onGridReady="$emit('field-event', { action: 'onMounted' })"
				:pageSize="pageSize"
			/>
		</div>
	</div>
</template>

<script>
import TableActionEditorService from '../../../BlockEditor/TableActionEditor/table-action-edtior-service';
import NewTableView from '@/components/common/TableView/NewTableView';
import { unflatten } from '@/utils/helpers';

export default {
	name: 'TableDisplay',
	components: {
		NewTableView,
	},
	props: {
		rows: { type: Array },
		headers: { type: Array },
		isSelectionOn: { type: Boolean },
		isMultipleSelection: { type: Boolean },
		isSearchOn: { type: Boolean },
		pageSize: { type: Number, default: 5 },
		selectedRows: { type: [Array, Object] },
		isEditMode: { type: Boolean, default: false },
		fieldsEditable: { type: Boolean, default: true },
		addRowEnabled: { type: Boolean, default: false },
		columnOrder: { type: String },
	},
	computed: {
		tableHeaders() {
			const fieldsList = TableActionEditorService.columnDefsFromPreviousSteps(this.rows);

			// Keep order of headers
			if (this.columnOrder === TableActionEditorService.TABLE_COLUMN_ORDER_CUSTOM) {
				return this.headers.map((header) => fieldsList.find((f) => f.headerName === header));
			}

			// Or, by default, return headers in the order they are in the fieldsList
			return fieldsList.filter((f) => this.headers.includes(f.headerName));
		},
		localSelectedRows: {
			set(selectedRows) {
				let valueToUpdate = selectedRows;
				if (this.isSelectionOn && !this.isMultipleSelection) {
					valueToUpdate = selectedRows.length > 0 ? selectedRows[0] : null;
				}
				this.$emit('update:selectedRows', unflatten(valueToUpdate)); // Note that we unflatten here, we get flatten data from TableField
			},
			get() {
				return Array.isArray(this.selectedRows) ? this.selectedRows : [this.selectedRows];
			},
		},
	},

	data() {
		return {};
	},
};
</script>

<style scoped lang="scss">
.table-container-layout {
	::v-deep(.ag-theme-alpine) {
		height: 243px; //200px;
	}
}
.table-container-layout {
	.table-field-layout {
		::v-deep(.ag-invisible) {
			display: none !important;
		}
		::v-deep(.ag-checkbox) {
			margin: 0 24px 0 8px;
		}
		::v-deep(.ag-cell) {
			text-align: left;
		}
	}

	@media (max-width: $device-sm) {
		background-color: var(--widget-field-mobile-bg) !important;
		border-radius: 6px;
	}
	// Small devices (landscape phones, 576px and up)
	@media (min-width: 576px) {
		// ::v-deep {
		// 	.v-data-table__wrapper {
		// 		max-height: 600px;
		// 		overflow: auto;
		// 	}
		// }
	}
}
</style>
